import React from "react";
import ModalSkeleton from "../../components/ModalSkeleton";
import { AreYouSureIcon } from "../../constant";
import classes from "./AreYouSure.module.css";
import ModalAction from "../../components/ModalAction";
const AreYouSureModal = ({ show, setShow, title="Booking", description, onConfirm,data ,loading}) => {

  console.log("data ==> are you sure modal", data);
  return (
    <ModalSkeleton show={show} setShow={setShow} width="498px">
      <div className={classes.wrapper}>
        <div>
          <AreYouSureIcon />
        </div>
        <div>
          <h3 className={classes.title}>Are Your Sure?</h3>
          <p className={classes.description}>
            Do you really want to cancel {title} <span className={classes.shine}>{data}</span>? After cancelling you can’t
            undo this action.
          </p>
        </div>
        <ModalAction
          onCancel={() => setShow(false)}
          onConfirm={onConfirm}
          confirmText="Confirm"
          cancelText="Cancel"
          loading={loading}
        />  
      </div>
    </ModalSkeleton>
  );
};

export default AreYouSureModal;
